<!-- Modern Enterprise Waiter Details -->
<div class="waiter-details-container">
  <!-- Page Header -->
  <div class="page-header">
    <div class="header-content">
      <div class="header-main">
        <button class="btn btn-outline-secondary btn-back" routerLink="/admin/waiter">
          <i class="fas fa-arrow-left"></i>
        </button>
        <div class="header-icon">
          <i class="fas fa-user-tie"></i>
        </div>
        <div class="header-text">
          <h1 class="page-title">{{ summary?.waiter_name || 'Waiter Details' }}</h1>
          <p class="page-description">View waiter balance summary and transaction history</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Summary Cards Row -->
  <div class="summary-cards">
    <div class="row g-3">
      <div class="col-md-6 col-lg-3">
        <div class="summary-card">
          <div class="summary-card-icon total-icon">
            <i class="fas fa-wallet"></i>
          </div>
          <div class="summary-card-content">
            <span class="summary-card-label">Total Amount</span>
            <h3 class="summary-card-value">{{ summary?.total || 0 | currency: ' ₦' }}</h3>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3">
        <div class="summary-card">
          <div class="summary-card-icon cash-icon">
            <i class="fas fa-money-bill-wave"></i>
          </div>
          <div class="summary-card-content">
            <span class="summary-card-label">Cash Balance</span>
            <h3 class="summary-card-value">{{ summary?.cash_transactions || 0 | currency: ' ₦' }}</h3>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3">
        <div class="summary-card">
          <div class="summary-card-icon transfer-icon">
            <i class="fas fa-exchange-alt"></i>
          </div>
          <div class="summary-card-content">
            <span class="summary-card-label">Wallet Transfer Balance</span>
            <h3 class="summary-card-value">{{ summary?.transfer_transactions || 0 | currency: ' ₦' }}</h3>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3">
        <div class="summary-card">
          <div class="summary-card-icon pos-icon">
            <i class="fas fa-credit-card"></i>
          </div>
          <div class="summary-card-content">
            <span class="summary-card-label">Card (POS) Balance</span>
            <h3 class="summary-card-value">{{ summary?.pos_transactions || 0 | currency: ' ₦' }}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Transaction History Panel -->
  <div class="data-panel">
    <div class="panel-header">
      <div class="panel-title">
        <div class="title-icon">
          <i class="fas fa-receipt"></i>
        </div>
        <div class="title-content">
          <div class="title-text">Transaction History</div>
          <div class="title-subtitle">Complete record of waiter transactions</div>
        </div>
      </div>
    </div>

    <div class="panel-body">
      <div class="table-container">
        <table class="table align-middle">
          <thead>
            <tr>
              <th>
                <div class="th-content">
                  <i class="fas fa-hashtag me-2"></i>
                  Order ID
                </div>
              </th>
              <th>
                <div class="th-content">
                  <i class="fas fa-chair me-2"></i>
                  Table
                </div>
              </th>
              <th>
                <div class="th-content">
                  <i class="fas fa-coins me-2"></i>
                  Amount
                </div>
              </th>
              <th>
                <div class="th-content">
                  <i class="fas fa-credit-card me-2"></i>
                  Payment Method
                </div>
              </th>
              <th>
                <div class="th-content">
                  <i class="fas fa-calendar-alt me-2"></i>
                  Date
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (item of tnxHistory; track $index) {
              <tr class="txn-row">
                <td>
                  <span class="order-id-badge">
                    {{ item?.order?.uid }}
                  </span>
                </td>
                <td>
                  <span class="table-name">
                    <i class="fas fa-qrcode me-1 text-muted"></i>
                    {{ item?.order?.barcode_details.name }}
                  </span>
                </td>
                <td>
                  <span class="amount-value">{{ item?.amount | currency: ' ₦' }}</span>
                </td>
                <td>
                  <span class="badge badge-soft-info badge-dot">
                    {{ item?.payment_method }}
                  </span>
                </td>
                <td>
                  <span class="date-text">{{ item?.order?.transaction_date | date:'medium' }}</span>
                </td>
              </tr>
            } @empty {
              <tr>
                <td colspan="5">
                  <div class="empty-state">
                    <div class="empty-icon">
                      <i class="fas fa-receipt fa-3x"></i>
                    </div>
                    <div class="empty-content">
                      <h5>No Transactions Yet</h5>
                      <p>This waiter has no recorded transactions at the moment.</p>
                    </div>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>

    <!-- Pagination Footer -->
    @if (size > pageSize) {
      <div class="panel-footer">
        <div class="pagination-container">
          <div class="pagination-info">
            <span>Showing page {{ page }} of {{ (size / pageSize) | number:'1.0-0' }}</span>
          </div>
          <ngb-pagination
            [collectionSize]="size"
            [(page)]="page"
            [pageSize]="pageSize"
            [maxSize]="5"
            [rotate]="true"
            [ellipses]="false"
            [boundaryLinks]="true"
            (pageChange)="refresh($event)"
            class="modern-pagination">
          </ngb-pagination>
        </div>
      </div>
    }
  </div>
</div>
